export default __webpack_public_path__ + "static/media/blog-post-01.9ca524e5.jpg";